import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { isRateLockdown } from "./GridComponents/CommonComponents";

export interface AlertBoxProps {
    showModal: boolean;
    message: any;
    handleNo: any;
    title?: string;
    statusIntId?: any;
    acceptanceRequired?: any;
    isPilot?: boolean;
    handleCheckboxChange?: any;
    accepted?: any;
    effectiveDate?: any;
    reqCreatedDate?: any;
    externalClass?:any
}

export interface AlertBoxState {
    showModal: boolean;
}

export class AlertBox extends React.Component<AlertBoxProps, AlertBoxState> {
    constructor(props) {
        super(props);
        this.state = { showModal: false };
    }

    render() {
        return (
            <div className={this.props.externalClass}>
                {this.props.showModal && (
                    <div className="containerDialog">
                        <div className="containerDialog-animation">
                            <div className={isRateLockdown(this.props.acceptanceRequired, this.props.effectiveDate, this.props.reqCreatedDate, this.props.isPilot, true, this.props.statusIntId) ? "col-10 col-sm-7 col-xl-4 shadow containerDialoginside vpwrap" : "col-10 col-sm-7 col-xl-4 shadow containerDialoginside"}>
                                <div className="row blue-accordion">
                                    <div className="col-12 pt-2 pb-2 fontFifteen">
                                        {this.props.title ? this.props.title : "Alert"}
                                    </div>
                                </div>
                                <div className="row text-center">
                                    <div className={isRateLockdown(this.props.acceptanceRequired, this.props.effectiveDate, this.props.reqCreatedDate, this.props.isPilot, true, this.props.statusIntId) ? "col-12 text-dark mt-4 pl-2 px-4 text-left mb-3" : "col-12 text-dark mt-4 pl-2 pr-2"}>{this.props.message}</div>
                                </div>
                                {isRateLockdown(this.props.acceptanceRequired, this.props.effectiveDate, this.props.reqCreatedDate, this.props.isPilot, true, this.props.statusIntId) &&
                                    <div className="col-12 mt-1 pl-0">
                                        <label className="container-R d-flex mb-0 pb-3">
                                            <span className="Introduction-line-height ml-1">I understand</span>
                                            <input
                                                type="checkbox"
                                                onChange={(e) => this.props.handleCheckboxChange(e, "isRateLockdownAccepted")}
                                            />
                                            <span className="checkmark-R checkPosition checkPositionTop" style={{ left: "0px" }}></span>
                                        </label>
                                    </div>
                                }
                                <div className="col-12 mt-4 mb-4 text-center font-regular">
                                    <button
                                        type="button"
                                        disabled={isRateLockdown(this.props.acceptanceRequired, this.props.effectiveDate, this.props.reqCreatedDate, this.props.isPilot, true, this.props.statusIntId) ? isRateLockdown(this.props.acceptanceRequired, this.props.effectiveDate, this.props.reqCreatedDate, this.props.isPilot, true, this.props.statusIntId)  && this.props.accepted ? false : true : false}
                                        onClick={this.props.handleNo}
                                        className="btn button button-bg shadow mb-2 mb-xl-0">
                                        <FontAwesomeIcon icon={faCheckCircle} className="mr-2" />
                                        OK
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default AlertBox;
